export default "/images/individual-user-logo.svg?e11a26f3403151b03e4b2d8a3c1863b3";